import {Component, ElementRef, Input, Renderer2, ViewChild} from '@angular/core';
import {Map} from 'leaflet';

@Component({
  selector: 'app-map-settings',
  templateUrl: './map-settings.component.html',
})
export class MapSettingsComponent {
  @ViewChild('mapSettingsContainer') mapSettingsContainer: ElementRef;
  @Input() map: Map;
  controlVisibilityState = false;

  constructor(
    private renderer: Renderer2,
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.mapSettingsContainer !== undefined) {
        if (!this.mapSettingsContainer.nativeElement.contains(e.target)) {
          this.controlVisibilityState = false;
        }
      }
    });
  }

  toggleControl() {
    this.controlVisibilityState = !this.controlVisibilityState;
  }
}
